import React from 'react'
import { Control, FieldErrors } from 'react-hook-form/dist/types'
import { ControlledPhoneInput } from 'transfix-form/components'
import ControlledTextField from 'transfix-form/components/ControlledTextInput'
import { Box } from 'transfix-ui/core'
import { TProvideInsuranceSchema } from './ProvideInsuranceSchema'
import { getErrorMessage } from './utils'

interface IProvideInsuranceFormField {
  control: Control
  errors: FieldErrors
  name: keyof TProvideInsuranceSchema
  placeholder: string
  label: string
  type?: string
}
const ProvideInsuranceFormField = ({
  control,
  errors,
  label,
  name,
  placeholder,
  type = 'text',
}: IProvideInsuranceFormField) => {
  if (type === 'number') {
    return (
      <Box mb={2}>
        <ControlledPhoneInput
          name={name}
          control={control}
          PhoneInputProps={{
            label,
            required: true,
            validationMessage: getErrorMessage(errors, name),
            invalid: !!getErrorMessage(errors, name),
            large: true,
          }}
        />
      </Box>
    )
  }

  return (
    <Box mb={2}>
      <ControlledTextField
        name={name}
        control={control}
        TextInputProps={{
          type,
          validationMessage: getErrorMessage(errors, name),
          error: !!getErrorMessage(errors, name),
          placeholder,
          required: true,
          large: true,
          dataTest: `input-${name}`,
          label,
        }}
      />
    </Box>
  )
}

export default ProvideInsuranceFormField
